import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faArrowUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";

import "aos/dist/aos.css";
import "../App.css";
import logoDark from "../assets/logo.png";
import logo from "../logo-header.png";
import favicon from "../assets/epaging-favicon.png";
import ThemeToggle from "./ThemeToggle";

const Header = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <>
      <div className="page-wrapper">
        <div className="topbar">
          <div className="container">
            <div className="topbar__inner">
              <a href="/" className="topbar__toggler main-header__toggler">
                <img src={logo} alt="epaging" width={"60"} />
              </a>
              <div className="topbar__logo">
                <Link to="/">
                  <img src={logoDark} alt="Epaging React" width="200" />
                </Link>
              </div>
              <div className="topbar__social">
                <p className="topbar__social__text">Follow Us</p>
                <a
                  href="https://www.linkedin.com/company/epaging/posts/?feedView=all"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin aria-hidden="true" />
                  <span className="sr-only">Linkedin</span>
                </a>
                <a
                  href="https://wa.me/923435350202"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp aria-hidden="true" />
                  <span className="sr-only">Whatsapp</span>
                </a>
                <a
                  href="https://www.instagram.com/epagingpvtltd/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram aria-hidden="true" />
                  <span className="sr-only">Instagram</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <header className="main-header sticky-header sticky-header--normal">
          <div className="container">
            <div className="main-header__inner">
              <nav
                className={`main-header__nav main-menu ${
                  isMobileMenuOpen ? "mobile-open" : ""
                }`}
              >
                <ul className="main-menu__list">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about">About</Link>
                  </li>
                  <li className="dropdown">
                    <NavLink
                      to="/solutions"
                      className={({ isActive }) =>
                        `drop-down ${isActive ? "active" : ""}`
                      }
                    >
                      <div className="select">
                        <div className="selected">
                          Solutions
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="1em"
                            viewBox="0 0 512 512"
                            className="arrow"
                          >
                            <path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                          </svg>
                        </div>
                      </div>
                    </NavLink>
                    <ul>
                      <li>
                        <Link to="/solutions#ai-agents">
                          AI Agents & Voice Automation
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions#ai-surveillance">
                          AI Video & Image Intelligence
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions#erp">
                          Enterprise ERP & Business Systems
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions#managed-it-cloud">
                          Managed IT & Cloud
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions#voip">
                          VoIP & Unified Communications
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions#integration">
                          Systems Integration & Data Sync
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions#bpo">
                          Remote Support & Managed BPO
                        </Link>
                      </li>
                      <li>
                        <Link to="/solutions#software-dev">
                          Software, Web & App Development
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="/gallery">Gallery</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                </ul>
              </nav>

              <div className="main-header__right">
                <ThemeToggle className="main-header__theme-toggle" />
                <div
                  className="mobile-nav__btn mobile-nav__toggler"
                  aria-expanded={isMobileMenuOpen}
                  onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <Link to="/contact" className="lotech-btn main-header__btn">
                  <span>
                    Contact Us
                    <span className="lotech-btn__icon">
                      <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                    </span>
                  </span>
                </Link>
              </div>

              {isMobileMenuOpen && (
                <div className="mobile-nav__wrapper expanded">
                  <div
                    className="mobile-nav__overlay"
                    onClick={() => setMobileMenuOpen(false)}
                  ></div>
                  <div className="mobile-nav__content">
                    <span
                      className="mobile-nav__close"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      &times;
                    </span>
                    <div className="logo-box">
                      <a href="/" aria-label="logo image">
                        <img src={favicon} alt="epaging" />
                      </a>
                    </div>
                    <nav className="main-menu__nav">
                      <ul className="main-menu__list">
                        <li>
                          <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                            Home
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/about"
                            onClick={() => setMobileMenuOpen(false)}
                          >
                            About
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/solutions"
                            onClick={() => setMobileMenuOpen(false)}
                          >
                            Solutions
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/gallery"
                            onClick={() => setMobileMenuOpen(false)}
                          >
                            Gallery
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/contact"
                            onClick={() => setMobileMenuOpen(false)}
                          >
                            Contact
                          </Link>
                        </li>
                      </ul>

                      <ul className="mobile-nav__contact list-unstyled">
                        <li>
                          <i className="fa fa-envelope"></i>{" "}
                          <a href="mailto:info@epaging.net">info@epaging.net</a>
                        </li>
                        <li>
                          <i className="fa fa-phone-alt"></i>{" "}
                          <a href="tel:02134327000">021-3432-7000</a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              )}
            </div>
          </div>
        </header>
      </div>
    </>
  );
};

export default Header;
